<mat-nav-list>
  <a *ngFor="let item of routes" mat-list-item [routerLinkActive]="'active-link'" [routerLink]="['/', item?.path]">
    <mat-icon color="primary" class="sidenav-icon" color="primary">{{ item?.data.icon }}</mat-icon>
  </a>

   <!-- Logout fixed at bottom -->
  <div class="logout-container">
    <a mat-list-item [routerLink]="['']">
      <mat-icon class="sidenav-icon" color="primary">logout</mat-icon>
    </a>
  </div>
</mat-nav-list>
